import React from 'react';
import { Check } from 'lucide-react';
import { whyWorkData } from '../data/mockData';

const WhyWorkWithMe = () => {
  return (
    <section className="section-padding bg-[#0a0a0a]">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div>
            <span className="inline-block text-sm font-medium text-[#c9a962] tracking-wider uppercase mb-4">
              Why Choose Me
            </span>
            
            <h2 className="heading-1 text-white mb-6">
              Why Work With Me
            </h2>
            
            <p className="body-large text-[#b3b3b3] mb-10">
              I don't just create pretty content — I create content with purpose. Here's what sets my work apart.
            </p>
            
            {/* Benefits List */}
            <div className="space-y-6">
              {whyWorkData.map((item) => (
                <div key={item.id} className="flex gap-4">
                  <div className="flex-shrink-0 w-6 h-6 bg-[#c9a962] flex items-center justify-center">
                    <Check size={14} className="text-[#0a0a0a]" />
                  </div>
                  <div>
                    <h3 className="heading-3 text-white mb-1">
                      {item.title}
                    </h3>
                    <p className="body-regular text-[#b3b3b3]">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Image Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="aspect-[3/4] overflow-hidden image-hover border border-[#2a2a2a]">
                <img 
                  src="https://images.unsplash.com/photo-1600891964599-f61ba0e24092?w=600&q=80"
                  alt="Food Photography"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="aspect-square overflow-hidden image-hover border border-[#2a2a2a]">
                <img 
                  src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&q=80"
                  alt="Restaurant Interior"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="space-y-4 pt-8">
              <div className="aspect-square overflow-hidden image-hover border border-[#2a2a2a]">
                <img 
                  src="https://images.unsplash.com/photo-1552693673-1bf958298935?w=600&q=80"
                  alt="Beauty Clinic"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="aspect-[3/4] overflow-hidden image-hover border border-[#2a2a2a]">
                <img 
                  src="https://images.unsplash.com/photo-1538333581680-29dd4752ddf2?w=600&q=80"
                  alt="Café Interior"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyWorkWithMe;
